<template>
  <div style="width: 100vw; height: 100vh; position: relative;">
    <div v-if="loadingPage" style="
        display: block;
        width: 50%;
        height: 100vh;
        text-align: center;
        margin: auto;
        padding-top: 15%;
      ">
      <v-progress-circular :size="200" :width="20" color="primary" indeterminate></v-progress-circular>
    </div>

    <v-card v-if="pageLoaded"
      style="position: fixed; bottom: 5%; right: 26%; z-index: 2000; min-width: 120px; min-height: 60px; background-color: transparent;"
      elevation="0">
      <v-card-text style="display: flex; gap: 8px; justify-content: center; align-items: center;">
        <v-btn @click="changeMode('map')" color="primary" dark><v-icon small color="white"
            dark>mdi-map-marker</v-icon></v-btn>
        <v-btn @click="changeMode('sinotico')" color="primary" dark><v-icon small color="white"
            dark>mdi-bus-stop</v-icon></v-btn>
      </v-card-text>
    </v-card>

    <!-- DIV do mapa -->
    <div v-if="pageLoaded" v-show="mode === 'map'" style="width: 75%; height: 100vh; float: left;">
      <l-map ref="map" :zoom="currentZoom" :center="currentCenter" :minZoom="minZoom" :maxZoom="maxZoom"
        @update:center="centerUpdate" @update:zoom="zoomUpdate" @click="mapClicked" :options="mapOptions"
        style="width: 100%; height: 100%; z-index: 1">

        <l-tile-layer :url="url" :attribution="attribution" />

        <!-- Marcadores de veículos -->
        <Vue2LeafletRotatedMarker v-for="(veiculo, k) in veiculosFiltrados" :key="`${veiculo.id_veiculo}-${k}`"
          :lat-lng="latLng(veiculo.lat, veiculo.lng)" :visible="true" :icon="getIcon(veiculo)"
          :rotationAngle="parseInt(veiculo.rumo)" :rotationOrigin="'15px 15px'">

          <l-popup :options="{ maxWidth: 'fit-content' }">
            <div>
              <pre><b>{{ $t('videowall.code') }}:</b> {{ veiculo.cod_veiculo }}</pre>
              <pre><b>{{ $t('videowall.plate') }}:</b> {{ veiculo.placa }}</pre>
              <pre><b>{{ $t('videowall.line') }}:</b> {{ veiculo.nome_linha || $t('system.na') }}</pre>
              <pre><b>{{ $t('videowall.driver') }}:</b>{{ veiculo.matricula_motorista ? `(${veiculo.matricula_motorista})` : $t('system.na') }} {{ veiculo.nome_motorista || '' }}</pre>
              <pre><b>{{ $t('videowall.speed') }}:</b> {{ veiculo.velocidade }} km/h</pre>
              <pre><b>{{ $t('videowall.lastPosition') }}:</b> {{ veiculo.dt_gps }}</pre>
              <pre><b>{{ $t('videowall.lastTicketing') }}:</b> {{ veiculo.dt_bilhetagem }}</pre>
              <br>
              <button @click="veiculoClicked(veiculo)" :style="{
                backgroundColor: veiculoSelecionado === veiculo ? '#ff5722' : '#4CAF50',
                color: 'white',
                border: 'none',
                padding: '5px 10px',
                borderRadius: '3px',
                cursor: 'pointer',
                fontSize: '12px'
              }">
                {{ veiculoSelecionado === veiculo ? $t('videowall.cleanFilter') : $t('videowall.filterLine') }}
              </button>
            </div>
          </l-popup>

          <l-tooltip :content="veiculo.cod_veiculo"
            :options="{ permanent: true, direction: 'top', opacity: 1.0, className: 'veiculo__tooltip' }">
          </l-tooltip>
        </Vue2LeafletRotatedMarker>
      </l-map>
    </div>

    <div v-if="pageLoaded" v-show="mode === 'sinotico'" style="width: 75%; height: 100vh; float: left;">
      <DashSinotico style="width: 100%; height: 80%; overflow-y: auto;" :veiculos="veiculosOnline" />
    </div>

    <v-navigation-drawer v-model="drawer" absolute permanent hide-overlay right dark width="25%">
      <v-container>
        <v-row justify="center">
          <v-img src="/imagens/prefeitura-nf.png" width="90%" height="100" class="ma-3" contain />
        </v-row>
        <v-row justify="center">
          <v-img src="/imagens/maisfri.png" width="90%" height="130" class="ma-3" contain />
        </v-row>
        <v-row class="py-0 mb-0 mt-0" justify="center">
          <v-col cols="12" align="center">
            <data-card :title="$tc('vehicle.self', 2)" :items="veiculosData" dark />
          </v-col>
        </v-row>
        <v-row class="py-0 mb-0 mt-0" justify="center">
          <v-col cols="12" align="center">
            <data-card :title="$tc('trip.self', 2)" :items="viagensData" dark />
          </v-col>
        </v-row>
        <v-row class="py-0 mb-0 mt-0" justify="center">
          <v-col cols="12" align="center">
            <data-card :title="$tc('ticket.self', 2)" :items="ticketsData" dark />
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<style>
.text-overlay {
  background: #fff;
  padding: 0 0.5em;
  border: 1px solid #aaa;
  border-radius: 0.1em;
}

.blink {
  animation: blink .2s infinite alternate;
}

.veiculo__tooltip {
  background-color: white;
  color: black;
  border: none;
  font-size: x-small;
  font-weight: bold;
  padding: 3px;
}

.cerca__tooltip {
  background-color: #4a4a4a;
  color: white;
  border: none;
  font-size: x-small;
  font-weight: bold;
  padding: 3px;
}

@keyframes blink {
  from {
    opacity: 0;
  }
}
</style>

<script>
import apiController from "@/utils/apiController";
import L from "leaflet";
import {
  LMap,
  LTileLayer,
  LTooltip,
  LPopup
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
import { mapGetters } from "vuex";
import DataCard from "./Cards/DataCard.vue";
import DashSinotico from "./DashSinotico.vue";

export default {
  name: "Videowall",
  components: {
    LMap,
    LTileLayer,
    LTooltip,
    Vue2LeafletRotatedMarker,
    LPopup,
    DataCard,
    DashSinotico
  },
  data: () => ({
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    zoom: 12,
    minZoom: 5,
    maxZoom: 18,
    loadingPage: false,
    pageLoaded: false,
    currentZoom: 12,
    currentCenter: null,
    mapOptions: {
      zoomSnap: 0.5,
    },
    veiculos: [],
    viagens: [],
    tickets: [],
    setup: {
      has_validador: 0
    },
    timeout: null,
    drawer: true,
    veiculoSelecionado: null,
    mode: 'map'
  }),
  props: [],
  watch: {
    '$i18n.locale'() {
      this.initialize();
    }
  },
  created() {
    this.populaSetup();
    this.initialize();
  },
  mounted() {
    this.$root.$emit("toogleMenu", false);
  },
  computed: {
    ...mapGetters('user', {
      id_usuario: 'id',
      nome_usuario: 'nome',
      razao_social: 'empresa',
      id_perfil_usuario: 'idPerfil',
      perfil_usuario: 'perfil',
      is_superadmin: 'super',
      token: 'acc'
    }),
    center() {
      return this.$store.getters['config/centerDefault'];
    },
    veiculosOnline() {
      return this.veiculos; // .filter((v) => v.gps_offline === 0);
    },
    veiculosFiltrados() {
      if (this.veiculoSelecionado) {
        return this.veiculosOnline.filter((v) => v.id_linha === this.veiculoSelecionado.id_linha);
      }

      return this.veiculosOnline;
    },
    veiculosData() {
      return [
        { label: this.$t('videowall.vehicleDate.total'), value: this.veiculos.length },
        { label: this.$t('videowall.vehicleDate.online'), value: this.totalcarrosonline, percentage: Math.round(this.totalcarrosonline / this.veiculos.length * 100) },
        { label: this.$t('videowall.vehicleDate.offline'), value: this.totalcarrosgpsoffline, percentage: Math.round(this.totalcarrosgpsoffline / this.veiculos.length * 100) }
      ];
    },
    viagensData() {
      return [
        { label: this.$t('videowall.tripData.planned'), value: this.viagens.total_viagens_previstas },
        { label: this.$t('videowall.tripData.completed'), value: this.viagens.total_viagens_realizadas, percentage: Math.round(this.viagens.total_viagens_realizadas / this.viagens.total_viagens_previstas * 100) || 0 },
        { label: this.$t('videowall.tripData.open'), value: this.viagens.total_viagens_abertas, percentage: Math.round(this.viagens.total_viagens_abertas / this.viagens.total_viagens_previstas * 100) || 0 },
        { label: this.$t('videowall.tripData.notCompleted'), value: this.viagens.total_viagens_nao_realizadas, percentage: Math.round(this.viagens.total_viagens_nao_realizadas / this.viagens.total_viagens_previstas * 100) || 0 }
      ];
    },
    ticketsData() {
      return [
        { label: this.$t('videowall.ticketsData.total'), value: this.tickets.total_tickets },
        { label: this.$t('videowall.ticketsData.open'), value: this.tickets.total_tickets_abertos, percentage: Math.round(this.tickets.total_tickets_abertos / this.tickets.total_tickets * 100) || 0 },
        { label: this.$t('videowall.ticketsData.closed'), value: this.tickets.total_tickets_fechados, percentage: Math.round(this.tickets.total_tickets_fechados / this.tickets.total_tickets * 100) || 0 }
      ];
    },
    totalcarrosonline() {
      return this.veiculos.filter(function (el) {
        return el.gps_offline === 0;
      }).length;
    },
    totalcarrosgpsoffline() {
      return this.veiculos.filter(function (el) {
        return el.gps_offline === 1;
      }).length;
    },
    hasValidador() {
      return this.setup.has_validador === 1;
    }
  },
  methods: {
    initialize() {
      this.currentCenter = this.center;
      if (!this.pageLoaded) {
        this.loadingPage = true;
        this.pageLoaded = false;
      }

      this.populaVeiculos();
      this.populaViagens();
      this.populaTickets();

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => this.initialize(), 30000);
    },
    populaSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        silent: true,
        onSuccess: (response) => {
          this.setup = Object.assign({}, response.data[0]);
        },
        onError: (e) => {
          console.log("Response : " + e.message);
          if (e.message == "Request failed with status code 401") {
            console.error(this.$t('videowall.error.errorAuthorizationLoadConfig'));
          }
        },
      });
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getVeiculosvideowall, {
        silent: true,
        onSuccess: (response) => {
          this.veiculos = response.data;
          this.loadingPage = false;
          this.pageLoaded = true;
        },
        onError: (e) => {
          this.loadingPage = false;
          this.pageLoaded = true;
          console.log("Response : " + e.message);
          if (e.message == "Request failed with status code 401") {
            console.error(this.$t('videowall.error.errorAuthorizationLoadVehicle'));
          }
        },
      });
    },
    populaViagens() {
      apiController.request(apiController.endpoints.getDashboardviagens, {
        silent: true,
        onSuccess: (response) => {
          this.viagens = response.data[0];
        },
        onError: (e) => {
          console.log("Response : " + e.message);
          if (e.message == "Request failed with status code 401") {
            console.error(this.$t('videowall.error.errorAuthorizationLoadTrips'));
          }
        },
      });
    },
    populaTickets() {
      apiController.request(apiController.endpoints.getDashboardtickets, {
        silent: true,
        onSuccess: (response) => {
          this.tickets = response.data[0];
        },
      }).catch(() => {});
    },
    getIcon(veiculo) {
      let color = "none";
      let title = "Online";
      let width = "30";
      let height = "30";
      let classname = "my-custom-pin";

      if (veiculo.gps_offline === 1) {
        classname += " blink";
        color = "red";
        title = `${veiculo.cod_veiculo}: ` + this.$t('videowall.gpsOffline');
      } else if (veiculo.sentido === 0) {
        color = "#008000"; // Verde para ida
        title = `${veiculo.cod_veiculo}: `+ this.$t('operation.go');
      } else if (veiculo.sentido === 1) {
        color = "#FF5722"; // Laranja para volta
        title = `${veiculo.cod_veiculo}: `+ this.$t('operation.back');
      } else {
        color = "#607D8B"; // Cinza para outros
        title = `${veiculo.cod_veiculo}: ` + this.$t('operation.others');
      }

      return L.divIcon({
        className: classname,
        html: `<svg width="${width}" height="${height}" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg"><title>${title}</title>
                <path opacity="0.1" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="${color}"/>
                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="${color}" stroke-width="2"/>
                <path d="M15 13L12.2014 10.2014V10.2014C12.0901 10.0901 11.9099 10.0901 11.7986 10.2014V10.2014L9 13" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
        iconAnchor: [15, 15],
        tooltipAnchor: [0, -15]
      });
    },
    latLng: function (lat, lng) {
      if (lat != null && lng !== null) {
        if (lat.trim() !== "0") {
          return L.latLng(lat, lng);
        } else {
          return L.latLng(-22.88746, -43.29185);
        }
      } else {
        return L.latLng(-22.88746, -43.29185);
      }
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },

    veiculoClicked(veiculo) {
      // Executa a lógica personalizada do duplo click
      if (this.veiculoSelecionado === veiculo) {
        this.veiculoSelecionado = null;
      } else {
        this.veiculoSelecionado = veiculo;
      }

      this.centerUpdate([veiculo.lat, veiculo.lng]);
    },
    mapClicked() {
      this.veiculoSelecionado = null;
    },
    changeMode(mode) {
      this.mode = mode;
    }
  },
};
</script>
